export const INTERNAL_METRICS = [
  { id: "fatigue", key: "fatigue", titleKey: "v2.overview.metrics.fatigue", helpKey: "v2.overview.metrics.fatigue_help" },
  { id: "intensity", key: "intensity", titleKey: "v2.overview.metrics.intensity", helpKey: "v2.overview.metrics.intensity_help" },
  { id: "rii", key: "rii", titleKey: "v2.overview.metrics.rii", helpKey: "v2.overview.metrics.rii_help" },
  { id: "load", key: "load", titleKey: "v2.overview.metrics.load", helpKey: "v2.overview.metrics.load_help" },
  { id: "mli", key: "mli", titleKey: "v2.overview.metrics.mli", helpKey: "v2.overview.metrics.mli_help" },
];

export const LOCKED_INTERNAL_BLOCK_ID = "trainability";

export const INTERNAL_BLOCKS = [
  { id: "trainability", titleKey: "v2.overview.trainability", locked: true },
  { id: "fatigue", titleKey: "v2.overview.metrics.fatigue" },
  { id: "intensity", titleKey: "v2.overview.metrics.intensity" },
  { id: "rii", titleKey: "v2.overview.metrics.rii" },
  { id: "load", titleKey: "v2.overview.metrics.load" },
  { id: "mli", titleKey: "v2.overview.metrics.mli" },
  { id: "trends", titleKey: "v2.overview.trends.title" },
];

export const DEFAULT_INTERNAL_BLOCK_ORDER = INTERNAL_BLOCKS.map((block) => block.id);

export function normalizeInternalBlockOrder(order) {
  const allowed = new Set(INTERNAL_BLOCKS.map((block) => block.id));
  const seen = new Set();
  const rest = [];
  (Array.isArray(order) ? order : []).forEach((id) => {
    if (!allowed.has(id) || id === LOCKED_INTERNAL_BLOCK_ID || seen.has(id)) return;
    seen.add(id);
    rest.push(id);
  });
  INTERNAL_BLOCKS.forEach((block) => {
    if (block.id !== LOCKED_INTERNAL_BLOCK_ID && !seen.has(block.id)) rest.push(block.id);
  });
  return [LOCKED_INTERNAL_BLOCK_ID, ...rest];
}

export const RANKING_METRICS = {
  fatigue: { unit: "%", badgeKey: "v2.overview.metrics.badge_body", digits: 0, deltaDigits: 1 },
  intensity: { unit: "PT", badgeKey: "v2.overview.metrics.badge_lower", digits: 2, deltaDigits: 2 },
  rii: { unit: "%", badgeKey: "v2.overview.metrics.badge_week", digits: 0, deltaDigits: 1 },
  load: { unit: "PT", badgeKey: "v2.overview.metrics.badge_lower", digits: 2, deltaDigits: 2 },
  mli: { unit: "%", badgeKey: "v2.overview.metrics.badge_week", digits: 0, deltaDigits: 1 },
};

export const TREND_METRICS = [
  { id: "note", titleKey: "v2.overview.trainability", unit: "/10", folded: true },
  { id: "fat", titleKey: "v2.overview.metrics.fatigue_short", unit: "%" },
  { id: "inten", titleKey: "v2.overview.metrics.intensity", unit: "PT" },
  { id: "rii", titleKey: "v2.overview.metrics.rii", unit: "%" },
  { id: "load", titleKey: "v2.overview.metrics.load_short", unit: "PT" },
  { id: "mli", titleKey: "v2.overview.metrics.mli", unit: "%" },
];
